module.exports = __webpack_public_path__ + "img/dr.441476f.svg";